import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=5ddb385e&scoped=true"
import script from "./HeaderCard.vue?vue&type=script&lang=js"
export * from "./HeaderCard.vue?vue&type=script&lang=js"
import style0 from "./HeaderCard.vue?vue&type=style&index=0&id=5ddb385e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb385e",
  null
  
)

export default component.exports